<script setup lang="ts">
import { useAppStore } from '~/stores/AppStore'
import { AppTheme } from '~/types'
const store = useAppStore()
const isMounted = ref(false)

onMounted(() => {
  isMounted.value = true
})
</script>

<template>
  <div
    class="spinner h-8 w-8 animate-spin rounded-full p-0.5"
    :class="isMounted ? 'visible' : 'invisible'"
  >
    <div
      class="relative h-full w-full rounded-full"
      :class="store.theme === AppTheme.DARK ? 'bg-black' : 'bg-white'"
    ></div>
  </div>
</template>
